import { render, staticRenderFns } from "./FFWeek.vue?vue&type=template&id=51475c72&scoped=true&"
import script from "./FFWeek.vue?vue&type=script&lang=js&"
export * from "./FFWeek.vue?vue&type=script&lang=js&"
import style0 from "./FFWeek.vue?vue&type=style&index=0&id=51475c72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51475c72",
  null
  
)

export default component.exports